import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { forkJoin, map, Observable } from 'rxjs';

import { CarService } from '@services/car.service';
import { CarItem } from '@models/car.model';
import { FilterDataService } from '@services/filter-data.service';
import { FilterDataMessage } from '@models/filter-data.model';

export const detailResolver: ResolveFn<Observable<{ car: CarItem | undefined; filterData: FilterDataMessage }>> = (route, state) => {
  const id = route.paramMap.get('id');
  const carService = inject(CarService);
  const filterDataService = inject(FilterDataService);

  return forkJoin({
    car: carService.getCarData(parseInt(id ?? '0')),
    filterData: filterDataService.getFilter(),
  }).pipe(
    map((data) => {
      const car = data.car;
      const filterData = data.filterData;
      return { car, filterData };
    }),
  );
};
